module.exports = __webpack_public_path__ + "static/media/endChallenge.fabc8b4a.svg";